import { useEffect, useState } from "react";

/** Debounce a fast-changing value (search boxes). */
export function useDebouncedValue<T>(value: T, ms = 250): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setV(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return v;
}

/** Set the browser tab title: "Pipeline · GramFather". */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · GramFather` : "GramFather";
    return () => {
      document.title = prev;
    };
  }, [title]);
}
